import moment from 'moment';

export const CASHBACK_LIMITED_TIME_START_DATE = '2026-05-01';

export const isCashbackLimitedTimeLocation = (location) => {
  const locationCreatedDate = location?.CreationDate || location?.createdAt;

  return (
    !!locationCreatedDate &&
    moment(locationCreatedDate).isAfter(CASHBACK_LIMITED_TIME_START_DATE)
  );
};
